import React, { useCallback, useState, useContext } from 'react';
import { Link, useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Rodal from 'rodal';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Page from '../../../layout/Page/Page';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Input from '../../../components/bootstrap/forms/Input';
import Button from '../../../components/bootstrap/Button';
import Logo from '../../../components/Logo';
import { userAuth } from '../../../contexts/userContext';
import useDarkMode from '../../../hooks/useDarkMode';
import '../../presentation/auth/Login.css';
import 'rodal/lib/rodal.css';
import { Ralert } from '../vhelper/Normarodallalert';
import Icon from '../../../components/icon/Icon';
import apiServicewt from '../../../api/apiServicewt';
import { useTranslation } from 'react-i18next';
import LANG, { getLangWithKey } from '../../../lang';
import showNotification from '../../../components/extras/showNotification';
import { useEffect } from 'react';
import Popovers from '../../../components/bootstrap/Popovers';
import Dropdown, {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from '../../../components/bootstrap/Dropdown';
import { useLanguageSwitch } from '../../../contexts/LanguageSwitchContext';
import apiService from '../../../api/apiService';
import { getConfig } from '../../../config.js';
import { dashboardMenu, demoPages } from '../../../menu';
import { serEmp } from '../../../contexts/serempContext';
import { useLoginSettings } from '../../../contexts/loginSettingsContext';
import { getClientSlug } from '../../../helpers/clientSlug';
import {
	changeGoogleTranslateLanguage,
	getStoredLanguage,
} from '../../../helpers/languageSwitch';
import { withClientIpHeader } from '../../../helpers/requestHeaders';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^\+?[0-9]+$/;

const detectIdentifierType = (value = '') => {
	const normalizedValue = String(value).trim();

	if (EMAIL_REGEX.test(normalizedValue)) return 'email';
	if (PHONE_REGEX.test(normalizedValue)) return 'phone';

	return '';
};

const requestEmailOtp = async (identifier) => {
	const otpUrl = new URL('/request_email_otp', getConfig().REACT_APP_WEB_LINK);
	const slug = getClientSlug();
	const fallbackPayload = { action: 'request_email_otp', email: identifier };

	otpUrl.searchParams.set('email', identifier);
	if (slug) {
		otpUrl.searchParams.set('slug', slug);
		fallbackPayload.slug = slug;
	}

	try {
		const headers = await withClientIpHeader({
			Accept: 'application/json',
			'sdk-authorization': '.',
		});
		const response = await fetch(otpUrl.toString(), {
			method: 'GET',
			headers,
		});
		const result = await response.json();

		if (result?.type) {
			return result;
		}
	} catch (error) {}

	return apiServicewt(fallbackPayload);
};

const loginWithEmailOtp = async (identifier, otp) => {
	const otpUrl = new URL('/login_with_email_otp', getConfig().REACT_APP_WEB_LINK);
	const slug = getClientSlug();
	const fallbackPayload = { action: 'login_with_email_otp', email: identifier, otp };

	otpUrl.searchParams.set('email', identifier);
	otpUrl.searchParams.set('otp', otp);
	if (slug) {
		otpUrl.searchParams.set('slug', slug);
		fallbackPayload.slug = slug;
	}

	try {
		const headers = await withClientIpHeader({
			Accept: 'application/json',
			'sdk-authorization': '.',
		});
		const response = await fetch(otpUrl.toString(), {
			method: 'GET',
			headers,
		});
		const result = await response.json();

		if (result?.type) {
			return result;
		}
	} catch (error) {}

	return apiServicewt(fallbackPayload);
};

const MobileOTP = () => {
	const { isLangSwitchEnabled } = useLanguageSwitch();
	const { t } = useTranslation();
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();
	const [selectedLanguage, setSelectedLanguage] = useState(getStoredLanguage());
	const [isNewUser, setIsNewUser] = useState('');
	const [isempty2, setIsempty2] = useState(false);
	const [loadalert, setLoadalert] = useState(false);
	const [msgloadalert, setMsgLoadalert] = useState('');
	const [msgtypeloadalert, setMsgtypeLoadalert] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const { token, setToken } = useContext(userAuth);
	const { serviceidcont, setServiceidcont } = useContext(serEmp);

	const { loginSettings, loginSettingsLang, loading: loginSettingsLoading } = useLoginSettings();
	const loginBgFromSettings = loginSettings?.background_image;
	const defaultLoginBg = `${process.env.PUBLIC_URL}/assets/img/abstract/Main_a.jpg`;
	const loginBg =
		loginBgFromSettings && String(loginBgFromSettings).trim()
			? loginBgFromSettings
			: defaultLoginBg;

	const closemodel = () => {
		setLoadalert(false);
	};
	const startmodel = () => {
		setLoadalert(true);
	};
	const closemodel2 = () => {
		setIsempty2(false);
	};
	const startmodel2 = () => {
		setIsempty2(true);
	};

	const styledBtn = {
		color: darkModeStatus ? 'dark' : 'light',
		hoverShadow: 'default',
		isLight: !darkModeStatus,
		size: 'lg',
	};

	useEffect(() => {
		document.body.classList.add('auth-page');
		return () => document.body.classList.remove('auth-page');
	}, []);

	useEffect(() => {
		const nextLanguage = getStoredLanguage();
		setSelectedLanguage(nextLanguage);
	}, []);

	const changeLanguage = async (lang) => {
		const nextLanguage = await changeGoogleTranslateLanguage(lang);
		setSelectedLanguage(nextLanguage);

		showNotification(
			<span className='d-flex align-items-center'>
				<Icon icon={getLangWithKey(nextLanguage)?.icon} size='lg' className='me-1' />
				<span>{`Language changed to ${getLangWithKey(nextLanguage)?.text}`}</span>
			</span>,
		);
	};

	useEffect(() => {
		const storedTheme = localStorage.getItem('theme');
		if (storedTheme !== null) {
			setDarkModeStatus(storedTheme === 'dark');
		}
	}, [setDarkModeStatus]);

	useEffect(() => {
		localStorage.setItem('theme', darkModeStatus ? 'dark' : 'light');
		document.documentElement.setAttribute('theme', darkModeStatus ? 'dark' : 'light');
	}, [darkModeStatus]);

	const navigate = useNavigate();
	const location = useLocation();
	const otpIdentifier = location.state?.otp_identifier || location.state?.phone_number || '';
	const otpIdentifierType =
		location.state?.otp_identifier_type ||
		detectIdentifierType(otpIdentifier) ||
		(location.state?.phone_number ? 'phone' : '');
	const requestThroughEmailEndpoint =
		location.state?.otp_request_endpoint === 'request_email_otp';
	const apiResult = location.state;
	const cameForLogin = location.state?.type === 'login';
	const serviceId = location.state?.service_id;
	const handleOnClick = useCallback(
		() =>
			navigate('/login', {
				state: { activeTab: requestThroughEmailEndpoint ? 'emailOtp' : 'phone' },
			}),
		[navigate, requestThroughEmailEndpoint],
	);

	const [otpinfo, setOtpinfo] = useState({ phone: '', otp: '' });

	const [isemptym, setIsemptym] = useState({ error: false, msg: t('*Required') });
	const [isemptyotp, setIsemptyotp] = useState({ error: false, msg: t('*Required') });

	// OTP countdown timer state
	const [countdown, setCountdown] = useState(120); // 2 minutes = 120 seconds
	const [isCountdownActive, setIsCountdownActive] = useState(true);
	const [isMounted, setIsMounted] = useState(true);

	// Countdown timer effect
	useEffect(() => {
		let interval = null;
		if (isCountdownActive && countdown > 0 && isMounted) {
			interval = setInterval(() => {
				if (isMounted) {
					setCountdown((countdown) => {
						if (countdown <= 1) {
							if (isMounted) {
								setIsCountdownActive(false);
							}
							return 0;
						}
						return countdown - 1;
					});
				}
			}, 1000);
		}

		// Cleanup function to prevent memory leaks
		return () => {
			if (interval) {
				clearInterval(interval);
			}
		};
	}, [isCountdownActive, countdown, isMounted]);

	// Cleanup on unmount
	useEffect(() => {
		return () => {
			setIsMounted(false);
		};
	}, []);

	// Format countdown display
	const formatCountdown = (seconds) => {
		const minutes = Math.floor(seconds / 60);
		const remainingSeconds = seconds % 60;
		return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
	};

	const fetchBranches = async (tokenData) => {
		const item = { action: 'get_branches_list' };

		try {
			const flechdata = await apiService(item, tokenData, setToken, navigate);

			if (Array.isArray(flechdata.data)) {
				const temp = flechdata.data.map((ele) => ({
					value: ele.branch_id,
					text: ele.branch_name,
				}));

				const defaultBranch = flechdata.data.find((branch) => branch.is_default);
				localStorage.setItem('branches-list', JSON.stringify(temp));
				localStorage.setItem(
					'selectedBranch',
					defaultBranch ? defaultBranch.branch_id : temp[0].value,
				);

				const selectedBranchName = temp?.find((branch) =>
					String(branch.value) === defaultBranch
						? defaultBranch.branch_id
						: temp[0].value,
				)?.text;

				window.dispatchEvent(
					new CustomEvent('branchChanged', {
						detail: { name: selectedBranchName },
					}),
				);
			} else {
				localStorage.removeItem('branches-list');
			}
		} catch (error) {
			localStorage.removeItem('branches-list');
			console.error('Error fetching branches:', error);
		}
	};

	// resend OTP
	async function resendotp() {
		if (!isMounted) return;

		try {
			const response = requestThroughEmailEndpoint
				? await requestEmailOtp(otpIdentifier)
				: await apiServicewt({
						action: 'request_otp',
						phone_number: otpIdentifier,
				  });
			// Handle response
			if (isMounted) {
				if (response.type === 'Success' || response.type === 'success') {
					showNotification(t('OTP resent successfully!'));
					// Reset countdown timer
					setCountdown(120);
					setIsCountdownActive(true);
				} else {
					startmodel();
					setMsgLoadalert(response.message);
					setMsgtypeLoadalert(response.type);
				}
			}

			//
		} catch (error) {
			console.error('Failed to resend OTP:', error);
			//showNotification(t('Failed to resend OTP. Please try again.'));
			if (isMounted) {
				startmodel();
				setMsgLoadalert(t('Failed to resend OTP. Please try again.'));
				setMsgtypeLoadalert('error');
			}
		}
	}

	const goToCalendar = (id) => {
		setServiceidcont(id);
		navigate(`../${dashboardMenu.Celender.path}`);
	};

	// OTP Submit
	const login_with_otp = async () => {
		if (isLoading || !isMounted) return;
		let cansendapi = true;

		// Reset previous errors
		if (isMounted) {
			setIsemptyotp({ error: false, msg: t('*Required') });
		}

		// Validate OTP field (don't check digit count as requested)
		if (!otpinfo?.otp || otpinfo.otp.trim() === '') {
			if (isMounted) {
				setIsemptyotp({ error: true, msg: t('OTP is required') });
			}
			cansendapi = false;
		}

		if (cansendapi && isMounted) {
			setIsLoading(true);
			try {
				const result =
					otpIdentifierType === 'email' || requestThroughEmailEndpoint
						? await loginWithEmailOtp(otpIdentifier, otpinfo.otp)
						: await apiServicewt({
								action: 'login_with_otp',
								phone_number: otpIdentifier,
								otp: otpinfo.otp,
						  });
				if (isMounted) {
					if (result.type === 'Success' || result.type === 'success') {
						// Redirect to the next page after successful OTP verification
						if (result.data.userrole === 'cus') {
							setToken(result.data);
							localStorage.setItem('user-auth', JSON.stringify(result.data));
							fetchBranches(result.data);

							if (cameForLogin && serviceId) {
								goToCalendar(serviceId);
							} else {
								navigate('/services');
							}
						}
					} else {
						startmodel();
						setMsgLoadalert(result.message);
						setMsgtypeLoadalert(result.type);
					}
				}
			} catch (error) {
				console.error('OTP verification failed:', error);
				// Handle error
			} finally {
				if (isMounted) {
					setIsLoading(false);
				}
			}
		}
	};

	return (
		<>
			<Ralert
				msgloadalert={msgloadalert}
				msgtypeloadalert={msgtypeloadalert}
				loadalert={loadalert}
				closemodel={closemodel}
			/>
			<div className='bg-img' style={{ backgroundImage: `url(${loginBg})` }}>
				<PageWrapper title={'Login'}>
					<div
						className='g-3'
						style={{
							position: 'absolute',
							top: 8,
							right: 8,
							display: 'flex',
							justifyContent: 'flex-end',
						}}>
						<div className='col-md-auto'>
							<div className='row g-3'>
								<div className='col-auto'>
									<Popovers trigger='hover' desc='Dark / Light mode'>
										<Button
											{...styledBtn}
											icon={darkModeStatus ? 'DarkMode' : 'LightMode'}
											onClick={() => setDarkModeStatus((prev) => !prev)}
											aria-label='Toggle fullscreen'
											data-tour='dark-mode'
										/>
									</Popovers>
								</div>
								{isLangSwitchEnabled && (
									<div className='col-auto'>
										<Dropdown>
											<DropdownToggle hasIcon={false}>
												<Button
													// eslint-disable-next-line react/jsx-props-no-spreading
													{...styledBtn}
													icon={getLangWithKey(selectedLanguage)?.icon}
													aria-label='Change language'
													data-tour='lang-selector'
												/>
											</DropdownToggle>
											<DropdownMenu
												isAlignmentEnd
												data-tour='lang-selector-menu'>
												{Object.keys(LANG).map((key) => (
													<DropdownItem key={LANG[key].lng}>
														<Button
															icon={LANG[key].icon}
															onClick={() =>
																changeLanguage(LANG[key].lng)
															}>
															{LANG[key].text}
														</Button>
													</DropdownItem>
												))}
											</DropdownMenu>
										</Dropdown>
									</div>
								)}
							</div>
						</div>
					</div>
					<Page
						className='p-0 container-xxl'
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							minHeight: '100vh',
						}}>
						<Card
							className='shadow-3d-dark'
							data-tour='login-page'
							style={{
								maxWidth: '400px',
								maxHeight: '545px',
							}}>
							<CardBody
								style={{
									// width: '600px',
									// height: '545px',
									//display: 'flex',
									justifyContent: 'center',
								}}>
								<div className='text-center my-3'>
									<Link
										to='/'
										className={classNames(
											'text-decoration-none  fw-bold display-2',
											{
												'text-dark': !darkModeStatus,
												'text-light': darkModeStatus,
											},
										)}>
										<Logo width={200} />
									</Link>
								</div>

								<OTPHeaderText />

								<form className='row g-4'>
									<div className='col-12'>
										<FormGroup id='login-otp' isFloating label='OTP'>
											<Input
												type='text'
												value={otpinfo?.otp}
												onChange={(e) => {
													setOtpinfo((pre) => {
														const temp = {
															...pre,
															otp: e.target.value,
														};
														return temp;
													});
												}}
											/>
										</FormGroup>
										{isemptyotp.error ? (
											<p
												style={{
													color: 'red',
													fontSize: '12px',
												}}>
												{isemptyotp.msg ? isemptyotp.msg : t('*Required')}
											</p>
										) : null}
									</div>
									<br />
									<div className='col-12'>
										<a
											style={{
												marginLeft: '8px',
												fontSize: 13,
											}}>
											{t("Didn't get the code?")}
										</a>
										{isCountdownActive && countdown > 0 ? (
											<span
												style={{
													marginLeft: '8px',
													fontSize: 13,
													color: '#6c757d',
												}}>
												{t('Resend in')} {formatCountdown(countdown)}
											</span>
										) : (
											<a
												onClick={() => resendotp()}
												style={{
													cursor: 'pointer',
													marginLeft: '8px',
													fontSize: 13,
													color: '#007bff',
												}}>
												{t('Resend')}
											</a>
										)}
									</div>

									<div className='col-12'>
										<Button
											color='info'
											className='w-100 py-3'
											onClick={login_with_otp}
											disabled={isLoading}>
											{t('Login')}
										</Button>
									</div>
									<br />
									{/* {!usernameInput && (
                                                <div className='col-12'>
                                                    <Button
                                                        color='light'
                                                        className='w-100 py-3'
                                                        onClick={handleOnClick}
                                                        // onClick={() => verifyotp()}
                                                    >
                                                        Go back
                                                    </Button>
                                                </div>
                                            )} */}

									<div className='col-12'>
										<Button
											color='light'
											className='w-100 py-3'
											onClick={handleOnClick}>
											{t('Go back')}
										</Button>
									</div>
								</form>
							</CardBody>
						</Card>
						{/* </div>
                        </div> */}
					</Page>
				</PageWrapper>
			</div>
		</>
	);
};

const OTPHeaderText = () => {
	const { t } = useTranslation();
	const location = useLocation();
	const otpIdentifier = location.state?.otp_identifier || location.state?.phone_number || '';
	const otpIdentifierType =
		location.state?.otp_identifier_type || detectIdentifierType(otpIdentifier);
	const identifierLabel =
		otpIdentifierType === 'email' ? t('email address') : t('mobile number');
	const title =
		otpIdentifierType === 'email'
			? t('Login with Email OTP')
			: t('Login with Mobile Number');

	return (
		<>
			<div className='text-center h2 fw-bold mt-5'>{title}</div>
			<br />
			<br />
			<div>
				{t('We have sent OTP to your')} <strong>{otpIdentifier}</strong>.{' '}
				{t('Please enter the verification code sent to your {{target}}', {
					target: identifierLabel,
				})}
				.
			</div>
			<br />
		</>
	);
};

export default MobileOTP;
